import * as React from 'react'

import { observer } from 'mobx-react'

import Text from 'modules/core/components/Inputs/Text'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import type CompanyIdentificationForm from 'modules/settings/lib/forms/Identification'

interface Props {
  form: CompanyIdentificationForm
  isFranceLegalEntity?: boolean
  legalEntity?: LegalEntity
}

const CompanyIdentification = ({ form, isFranceLegalEntity, legalEntity }: Props) => {
  return (
    <div data-intercom-target="settings-legal-info">
      <Text
        mandatory
        label={i18n.t('settings.edit_company.legal_name')}
        field={form.get('legal_name')}
        readonly={legalEntity?.attributes.main}
      />

      <Text
        label={i18n.t('settings.edit_company.tin')}
        field={form.get('tin')}
        mandatory={hasFeature('payroll')}
        readonly={legalEntity?.attributes.main}
      />

      {isFranceLegalEntity && (
        <Text
          label={i18n.t('settings.edit_company.siret')}
          field={form.get('siret')}
          mandatory={hasFeature('payroll')}
          validation={() =>
            form.isValidSiret ? '' : i18n.t('settings.edit_company.invalid_siret_error')
          }
        />
      )}
    </div>
  )
}

export default observer(CompanyIdentification)
